module.exports = __webpack_public_path__ + "img/patro_5.a50087ab.png";